<ng-container *transloco="let t; read: 'reports'">
<div class="p-5 relative">
  <div>
    <drdp-title [title]="title"></drdp-title>
    <p>
      {{ t('classPlanning.description') }}
    </p>
  </div>
  <drdp-report-search [multiSelectClassrooms]="false"
    [multiSelectSites]="false"
    [is2025]="is2025"
    [onlyLocked]="false"
    [onlyActive]="true"
    [showLocale]="false"
    [showStudentSelect]="true"
    [canSelectAll]="true"
    [requiredFields]="requiredFields"
    (showReportClicked)="showReport($event)"
    (downloadReportClicked)="downloadReport($event)"
    (clearClicked)="handleClear()"></drdp-report-search>
  @if (!!reportData && !!result) {  
    @if ((searchValues?.is2025AgeGradeSelected || is2025) && accessActivityReport) {
      <div class="flex justify-end md:block md:absolute right-12 mt-10">
        <a (click)="goToActivityBank()" class="text-drdpblue-300 cursor-pointer"><i class="uil uil-file mr-1"></i>{{ t('classPlanning.goToActivityBank') }}</a>
      </div>
    }

    <div class="class-planning-report report-well" [ngClass]="[result.ageGroup, is2025 ? 'report-2025' : '']" id="report">
      @if (reportData.totalChildrenCount === 0) {
        <div class="text-center">{{ t('classPlanning.noChildren') }}</div>
      } @else {
        <h1>{{ is2025 ? t('classPlanning.reportHeading') : t('classPlanning.reportHeadingWithAgeGroup', { ageGroup: result.ageGroupName }) }}</h1>
        <ul class="intro">
          <!-- classroomName is server-supplied and is not translated here. -->
          <li [innerHTML]="t('classPlanning.childrenSelected', { count: reportData.totalChildrenCount, classroom: reportData.classroomName })"></li>
        </ul>
        <ul class="intro">
          <!-- The values inside <strong> are server-supplied and are not translated here. -->
          <li>{{ t('classPlanning.stateLabel') }} <strong>{{reportData.stateName}}</strong></li>
          <li>{{ t('classPlanning.agencyLabel') }} <strong>{{reportData.agencyName}}</strong></li>
          <li>{{ t('classPlanning.siteLabel') }} <strong>{{reportData.siteName}}</strong></li>
          <li>{{ t('classPlanning.teacherLabel') }} <strong>{{reportData.teacherOfRecordFullName}}</strong></li>
        </ul>
  
        @for (classPlanningDomain of reportData.domains; track classPlanningDomain) {
          <div [ngClass]="[domainClass(classPlanningDomain.code), result.ageGroup]" class="domain" style="overflow-x: auto;">
            <h2 class="!mt-4" [ngClass]="'icon-' + (is2025 ? classPlanningDomain.code.toLowerCase() : domainClass(classPlanningDomain.code))">{{classPlanningDomain.domainName}}</h2>
  
            @for (domainAgeGroup of classPlanningDomain.domainAgeGroups; track domainAgeGroup) {
              @for (ratingPeriod of domainAgeGroup.domainRatingPeriods; track ratingPeriod) {
                <drdp-median-domain-group
                  [ratingPeriod]="ratingPeriod"
                  [levels]="domainAgeGroup.levels"
                  [ageGroupCode]="domainAgeGroup.ageGroupCode"
                  [is2025]="is2025"
                  [showCount]="true">
                </drdp-median-domain-group>
              }
              <div class="table-container">
              <table class="rating-table data-table">
                <thead>
                  <tr>
                    <th class="nb measure-header"><h3>@if(is2025) { {{domainAgeGroup.ageGroupCode}} }</h3></th>
                    @for (level of domainAgeGroup.levels; track level) {
                      <th [ngClass]="level.displayLevelCode" class="level-header level-header-xxsmall" [style.width]="85/domainAgeGroup.levels.length + '%'">
                        {{level.levelName}}
                      </th>
                    }
                  </tr>
                </thead>
                <tbody>
                  @for (measure of domainAgeGroup.measures; track measure) {
                    <tr>
                      <th style="width: 220px !important;">
                        <div>{{measure.measureCode}}</div>
                        <div class="!font-normal" style="width: 150px !important;">{{measure.measureName}}</div>
                      </th>
    
                      @for (level of domainAgeGroup.levels; track level) {
                        <td class="student-cell">
                          @for (student of getMeasureLevelStudents(measure, level.levelCode); track student) {
                            <div class="student-list" [ngClass]="{'text-drdpblue-300 cursor-pointer underline': student.isLocked}"  (click)="student.isLocked && onMeasureLevelSelect(measure, level)">
                              {{student.firstName}} {{student.lastName | slice:0:3}}
                            </div>
                          }
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            }
          </div>
        }
      }
    </div>
  }
</div>
</ng-container>
